import { z } from "zod";

export const paymentDetailsSchema = z.object({
  amount: z
    .string()
    .min(1, "pages.payment.createPaymentLink.AMOUNT_REQUIRED")
    .regex(/^\d+(\.\d{1,2})?$/, "pages.payment.createPaymentLink.VALID_AMOUNT"),
  currency: z.string(),
  paymentFor: z.string().min(1, "PAYMENT_FOR_REQUIRED").max(500, "PAYMENT_FOR_MAX"),
  paymentCategory: z.string().min(1, "PAYMENT_CATEGORY_REQUIRED"),
  expiryDate: z.date({ required_error: "EXPIRY_DATE_REQUIRED" }),
});

export const selectRecipientsSchema = z.object({
  recipientsType: z.enum(["INDIVIDUALS", "GROUPS"]),
  recipientsOutSideGoalngo: z
    .array(z.string().email({ message: "VALID_RECIPIENTS_EMAIL" }))
    .min(1, { message: "RECIPIENTS_EMAIL_REQUIRED" })
    .max(50, { message: "RECIPIENTS_EMAIL_MAX" }),
});

export const registerFormFieldsSchema = z.object({
  registerFormFields: z.array(
    z.object({
      title: z.string(),
      required: z.boolean(),
      default: z.boolean().optional(),
      inserted: z.boolean().optional(),
      isCustom: z.boolean().optional(),
    })
  ),
});

export const reviewPaymentSchema = z.object({
  acceptTermsAndConditions: z.literal(true, { message: "ACCEPT_TERMS_AND_CONDITIONS" }),
});

export const createPaymentLinkSchemaSchema = paymentDetailsSchema
  .merge(selectRecipientsSchema)
  .merge(registerFormFieldsSchema)
  .merge(reviewPaymentSchema);

export type CreatePaymentLink = z.infer<typeof createPaymentLinkSchemaSchema>;
